module.exports = __webpack_public_path__ + "assets/img/rakumartandGoogle.1e6b5e07.svg";